<template>
  <div class="login auth " :class="site.id == 'GA' ? 'btn-vinculo' : ''">
    <!-- <pre>{{ current_brand }}</pre> -->
    <div class="auth__column auth__column--primary">
      <div
        class="auth__content auth__content--login d-flex flex-wrap text-center"
      >
        <div class="login__header" v-if="site.id == 'GA'">
          <contact-phones class="text-left d-none d-md-block" />
          <div
            v-if="site.url === 'https://serviciotecnico.gildemeisterautos.cl'"
          >
            <a
              v-if="site.label"
              :href="site.url"
              class="auth__external_gilde site-external"
              target="_blank"
              rel="noopener"
            >
              {{ site.label }}
              <i class="material-icons">exit_to_app</i>
            </a>
          </div>
          <div v-else>
            <a
              v-if="site.label"
              :href="site.url"
              class="auth__external site-external"
              target="_blank"
              rel="noopener"
            >
              {{ site.label }}
              <i class="material-icons">exit_to_app</i>
            </a>
          </div>
        </div>
        <div class="login__header" v-else>
          <contact-phones class="text-left d-none d-md-block" />
          <div
            v-if="site.url === 'https://serviciotecnico.gildemeisterautos.cl'"
          >
            <a
              v-if="site.label"
              :href="site.url"
              class="auth__external_gilde site-external"
              target="_blank"
              rel="noopener"
            >
              {{ site.label }}
              <i class="material-icons">exit_to_app</i>
            </a>
          </div>
          <div v-else>
            <div v-if="site.id == 'BRI'">
              <a
                v-if="site.label"
                :href="site.url"
                class="auth__external site-external"
                target="_blank"
                rel="noopener"
              >
                Ir a Shineraychile.cl
                <i class="material-icons">exit_to_app</i>
              </a>
            </div>
            <div v-else>
              <a
                v-if="site.label"
                :href="site.url"
                class="auth__external site-external"
                target="_blank"
                rel="noopener"
              >
                {{ site.label }}
                <i class="material-icons">exit_to_app</i>
              </a>
            </div>
          </div>
        </div>
        <div class="login__new">
          <div class="login__branding">
            <div v-if="site.id == 'BRI'">
              <logo
                :class="`logo--${site.id}`"
                logo="https://shineraychile.cl/content/uploads/2023/09/logo-shineray-negro.png"
              ></logo>
            </div>
            <div v-else>
              <logo
                :class="`logo--${site.id}`"
                :logo="current_brand && current_brand.logo"
              ></logo>
            </div>
          </div>
          <div class="login__header">
            <h1 class="login__title title title--l text-primary weight-bolder">
              Bienvenido(a) a nuestra Plataforma de Agendamiento
            </h1>
            <h1
              v-if="site.id == 'GA'"
              class="login__title title title--l text-primary weight-bolder"
            >
              <!---/Bienvenido(a) a nuestra Plataforma de Agendamiento--->
              Agenda tu Servicio
            </h1>
            <ul v-if="site.id == 'GA'" class="list-services">
              <li>Mantención de kilometraje</li>
              <li>Desabolladura y Pintura</li>
              <li>Cambio de Aceite</li>
              <li>Y más...</li>
            </ul>
            <div class="login__actions">
              <router-link class="button button--primary" to="/registro">
                <span class="button__text">Agendar hora</span>
              </router-link>
            </div>
            <div v-if="site.id == 'GA'" class="d-block d-lg-none">
              <contact-phones class=" text-center" />
            </div>
          </div>
        </div>
        <div class="login__exist">
          <login-box
            title="¿Tienes una hora agendada? Revisa aquí:"
            :code="$route.query.codigo_reserva"
          />
        </div>
      </div>
    </div>
    <div class="auth__column auth__column--secondary">
      <div
        class="auth__background background"
        :style="
          `background-image: url(${current_brand && current_brand.background});`
        "
      ></div>

      <div v-if="site.id == 'GA'">
        <h1 class="text-ga">Servicio Técnico Gildemeister Retail</h1>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo';
import LoginBox from '@/components/LoginBox';
import ContactPhones from '@/components/ContactPhones';

import { mapState } from 'vuex';

export default {
  name: 'Login',
  components: {
    Logo,
    LoginBox,
    ContactPhones,
  },
  data() {
    return {
      site: {
        id: process.env.VUE_APP_BRAND_ID || '',
        label: process.env.VUE_APP_BRAND_SITE_LABEL || '',
        url: process.env.VUE_APP_BRAND_SITE_URL || '',
      },
    };
  },
  computed: {
    ...mapState(['current_brand']),
  },
};
</script>
